const sectionCandidates = new Map();
const playedAutoSections = new Set();

function getCandidates(sectionKey) {
    if (!sectionCandidates.has(sectionKey)) {
        sectionCandidates.set(sectionKey, new Map());
    }
    return sectionCandidates.get(sectionKey);
}

export function registerMockupScrollHint(sectionKey, candidateKey, candidate) {
    if (!sectionKey || !candidateKey) return () => {};

    const candidates = getCandidates(sectionKey);
    candidates.set(candidateKey, candidate);

    return () => {
        const sectionMap = sectionCandidates.get(sectionKey);
        if (!sectionMap) return;

        sectionMap.delete(candidateKey);
        if (!sectionMap.size) {
            sectionCandidates.delete(sectionKey);
            playedAutoSections.delete(sectionKey);
        }
    };
}

export function playAutoMockupScrollHint(sectionKey) {
    if (!sectionKey || playedAutoSections.has(sectionKey)) return false;

    const registeredCandidates = Array.from(sectionCandidates.get(sectionKey)?.values() || []);
    const candidates = registeredCandidates
        .filter((candidate) => candidate.isEligible())
        .sort((a, b) => a.getPriority() - b.getPriority());

    const candidate = candidates[0];
    if (!candidate) return false;

    playedAutoSections.add(sectionKey);
    candidate.play();
    return true;
}
